import { useSendOnCopilotChannel } from '../channel/hooks/useSendOnCopilotChannel';
export const useCloseCopilot = () => {
  return useSendOnCopilotChannel('CLOSE_COPILOT');
};